"use strict";
// Shared types for customer communications. Lives in aven_types so it can be imported
// by both aven_backend (entity layer) and aven_contracts (API schemas) — avoids duplication
// and the ugly narrowing boundary that used to exist between backend enum ↔ contract literal.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MARKETING_TEXT_UTM_SOURCE = exports.MARKETING_EMAIL_UTM_SOURCE = exports.HARD_SMS_CHAR_LIMIT = exports.CommunicationMedium = exports.CommunicationDirection = exports.CommunicationStatus = void 0;
var CommunicationStatus;
(function (CommunicationStatus) {
    CommunicationStatus["completed"] = "completed";
    CommunicationStatus["failed"] = "failed";
    CommunicationStatus["blocked"] = "blocked";
    CommunicationStatus["pending"] = "pending";
    CommunicationStatus["duplicate"] = "duplicate";
})(CommunicationStatus || (exports.CommunicationStatus = CommunicationStatus = {}));
var CommunicationDirection;
(function (CommunicationDirection) {
    CommunicationDirection["inbound"] = "inbound";
    CommunicationDirection["outbound"] = "outbound";
})(CommunicationDirection || (exports.CommunicationDirection = CommunicationDirection = {}));
var CommunicationMedium;
(function (CommunicationMedium) {
    CommunicationMedium["rvm"] = "rvm";
    CommunicationMedium["call"] = "call";
    CommunicationMedium["sms"] = "sms";
    CommunicationMedium["mms"] = "mms";
    CommunicationMedium["email"] = "email";
    CommunicationMedium["zendeskChat"] = "zendeskChat";
    CommunicationMedium["mail"] = "mail";
    CommunicationMedium["website"] = "website";
    CommunicationMedium["remoteNotarization"] = "remoteNotarization";
    CommunicationMedium["pushNotification"] = "pushNotification";
    CommunicationMedium["doorKnockers"] = "doorKnockers";
    CommunicationMedium["megaphone"] = "megaphone";
    CommunicationMedium["app"] = "app";
})(CommunicationMedium || (exports.CommunicationMedium = CommunicationMedium = {}));
// Outbound SMS bodies longer than this are rejected. Twilio returns error 30019 (Content Size Exceeds Carrier Limit)
// once the carrier-aggregated payload exceeds carrier limits. Twilio's docs recommend staying at or below 320 chars
// for reliable deliverability across carriers, and our lowest observed 30019 failure was at 712 chars, so 320 leaves
// plenty of headroom while matching the documented threshold.
// See https://help.twilio.com/articles/360033806753-Maximum-Message-Length-with-Twilio-Programmable-Messaging-
exports.HARD_SMS_CHAR_LIMIT = 320;
/**
 * utm_source stamped on marketing email CTAs by OneTimeEmailCampaignDrip, which hardcodes the same
 * literal. DM attribution keys on it to claim the resulting traffic, so the two must stay in sync.
 * @TranslateToPython
 */
exports.MARKETING_EMAIL_UTM_SOURCE = 'email_marketing';
/**
 * utm_source stamped on marketing-text links. DM attribution keys on it to claim the resulting
 * traffic, so the sender and ETL must use the same value.
 * @TranslateToPython
 */
exports.MARKETING_TEXT_UTM_SOURCE = 'text_marketing';
